"use client";

import { motion } from "framer-motion";

import Image from "@/app/_components/Image";
import { FIFA_ASSET_VERSION } from "@/constants/vars.constants";

import styles from "./OMBCSection.module.scss";

export default function OMBCSection() {
  return (
    <section className={styles.section}>
      <motion.div
        className={styles.card}
        initial={{
          opacity: 0,
          y: 80,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        viewport={{
          once: true,
          amount: 0.25,
        }}
        transition={{
          duration: 0.7,
          ease: [0.25, 0.1, 0.25, 1],
        }}
      >
          <motion.div
            className={styles.content}
            initial="hidden"
            whileInView="visible"
            viewport={{
              once: true,
              amount: 0.3,
            }}
            variants={{
              hidden: {},
              visible: {
                transition: {
                  staggerChildren: 0.18,
                },
              },
            }}
          >
          <h2>
            Tomorrow&apos;s Legends onto the Field:
            <br />
            OMBC
          </h2>

          <motion.p
            variants={{
              hidden: {
                opacity: 0,
                y: 30,
              },
              visible: {
                opacity: 1,
                y: 0,
              },
            }}
            transition={{
              duration: 0.8,
            }}
          >
            The Official Match Ball Carriers (OMBC) are children who dream
            of becoming future football stars. As they walk onto the pitch
            alongside the players and hand the official match ball to the
            referee, football&apos;s next chapter and inspiration begin in
            their hands.
          </motion.p>

          <motion.a
            href="https://worldwide.kia.com/en/brand/brand-stories/official-match-ball-carrier/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
            variants={{
              hidden: {
                opacity: 0,
                y: 20,
              },
              visible: {
                opacity: 1,
                y: 0,
                transition: {
                  duration: 0.8,
                  ease: [0.25, 0.1, 0.25, 1],
                },
              },
            }}
          >
            Learn more
          </motion.a>
        </motion.div>

        <motion.a
          href="https://worldwide.kia.com/en/brand/brand-stories/official-match-ball-carrier/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.imageWrap}
          initial={{
            opacity: 0,
            scale: 0.92,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          viewport={{
            once: true,
          }}
          transition={{
            duration: 0.7,
            delay: 0.15,
            ease: [0.25, 0.1, 0.25, 1],
          }}
        >
          <Image
            src={`/fifa/fifa-feature.webp?v=${FIFA_ASSET_VERSION}`}
            alt="OMBC"
            title="OMBC"
            fill
            className={styles.image}
            sizes="(max-width: 768px) 100vw, 50vw"
            loading="lazy"
            quality={70}
          />
        </motion.a>
      </motion.div>
    </section>
  );
}